import { AssetType } from "@/app/types/generated/graphql";

export const demoTransactionFee = {
  id: "e8a75317-ce2d-4a84-b824-6f887cd96359",
  assetType: AssetType.Rec,
  buyerTxnFeePercent: 0.01,
  sellerTxnFeePercent: 0.01,
  minimumBuyerFee: 1,
  minimumSellerFee: 1,
  taxPercentage: null,
  __typename: "TransactionFee",
};

export const transactionFeeQuery = {
  read(_: any) {
    return demoTransactionFee;
  },
};
